import { BaseIcon, BaseIconProps } from '../BaseIcon';

// Replace these HTMLAttributes with your correct one
type ClearIconProps = Omit<BaseIconProps, 'children'>;

export const ClearIcon = ({ ...props }: ClearIconProps) => (
  <BaseIcon
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={12} cy={12.001} r={8} />
    <path
      d="M15 9.00098L9 15.001"
      stroke="white"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M9 9.00098L15 15.001"
      stroke="white"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
  </BaseIcon>
);

ClearIcon.displayName = 'ClearIcon';
